<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>New Agent Protocol</h2>
            <h3>Please insert agent details</h3>
        </div>
        <div slot="body">
            
            <agent-new @toggleIsDisabled="toggleIsDisabled" @readyToSave="readyToSave"></agent-new>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <div>
                <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                <button type="button" class="btn ok wider" @click="save" :disabled="isDisabled">Save</button>
            </div>
        </div>
    </modal>
</template>
   
<script>
    import { mapActions } from 'vuex'
    import Modal from './Modal'
    import AgentNew from '@/components/people/agents/AgentNew'

    export default {
        data: function() {
            return {
                isDisabled: true,
                updatedForm: null,
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'addAgent',
                'clearSelectedPerson'
            ]),
            toggleIsDisabled: function(isDisabled) {
                this.isDisabled = isDisabled;
            },
            readyToSave: function(updatedForm) {
                this.updatedForm = updatedForm;
            },
            cancel: function() {
                this.clearSelectedPerson();
                this.closeModal();
            },
            save: function() {
                if (this.updatedForm) {
                    this.addAgent();
                }
            }
        },
        components: {
            Modal,
            AgentNew
        }
    }
</script>


// WEBPACK FOOTER //
// AgentAdd.vue?3fc4011d